
export const getDamages = (data) => {
    if (noAnswers(data)) {
        return null
    }

    let id = data.form.fields.filter(field => {
        return field.title.includes('damages you suffered')
    }).map(field => field.id)[0]

    let answer = data.response.answers.filter(answer => {
        return answer.field.id === id
    })[0]

    return answer ? answer.text : null
}

export const getInjuries = (data) => {
    if (noAnswers(data)) {
        return null
    }

    let id = data.form.fields.filter(field => {
        return field.title.includes('list all the injuries')
    }).map(field => field.id)[0]

    let answer = data.response.answers.filter(answer => {
        return answer.field.id === id
    })[0]

    return answer ? answer.text : null
}

export const getAnnualIncome = (data) => {
    if (noAnswers(data)) {
        return null
    }

    let id = data.form.fields.filter(field => {
        return field.title.includes('annual income')
    }).map(field => field.id)[0]

    let answer = data.response.answers.filter(answer => {
        return answer.field.id === id
    })[0]

    return answer ? answer.text : null
}

export const getEdu = (data) => {
    if (noAnswers(data)) {
        return null
    }

    let id = data.form.fields.filter(field => {
        return field.title.includes('highest completed level of education')
    }).map(field => field.id)[0]

    let answer = data.response.answers.filter(answer => {
        return answer.field.id === id
    })[0]

    return answer && answer.choice ? answer.choice.label : null
}

const noAnswers = data => data.response.answers ? false : true